import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import parse from 'html-react-parser'

export const Preview = ({ allData }) => {
  const queryParams = new URLSearchParams(window.location.search)
  const projectId = queryParams.get('project')
  const pageId = queryParams.get('page')
  const themeId = queryParams.get('theme')
  const theme = allData.themes.filter((f) => f.themeId === themeId)
  const project = allData.projects.filter((f) => f.websiteProjectId === projectId)
  const websitePages = allData.pages.filter(
    (f) => f.websiteProjectId === projectId && f.websitePageId === pageId,
  )
  const webSettings = JSON.parse(project[0].websiteProjectSettings)
  document.documentElement.style.setProperty('--primaryColor', webSettings.primaryColor)
  document.documentElement.style.setProperty('--primaryHoverColor', webSettings.primaryHoverColor)
  document.documentElement.style.setProperty('--secondaryColor', webSettings.secondaryColor)
  document.documentElement.style.setProperty(
    '--secondaryHoverColor',
    webSettings.secondaryHoverColor,
  )
  document.documentElement.style.setProperty('--lightColor', webSettings.lightColor)
  document.documentElement.style.setProperty('--darkColor', webSettings.darkColor)
  return (
    <React.Fragment>
      <Helmet>
        {JSON.parse(theme[0].themeCSS).map((css, cssInd) => (
          <link key={cssInd} rel="stylesheet" href={css} />
        ))}

        {JSON.parse(theme[0].themeJS).map((js, jsInd) => (
          <script src={js} key={jsInd}></script>
        ))}
        <style>
          {websitePages[0].websitePageCSS !== null && parse(websitePages[0].websitePageCSS)}
        </style>
      </Helmet>
      {theme[0].themeCategory !== 'onepage' &&
        project[0].websiteProjectNavbar !== null &&
        (websitePages[0].defaultnav ? parse(project[0].websiteProjectNavbar) : null)}
      {websitePages[0].websitePageHTML !== null
        ? parse(websitePages[0].websitePageHTML)
        : project[0].websiteProjectNavbar === null && <div>Page not built!</div>}
      {theme[0].themeCategory !== 'onepage' &&
        project[0].websiteProjectFooter !== null &&
        (websitePages[0].defaultnav ? parse(project[0].websiteProjectFooter) : null)}
    </React.Fragment>
  )
}

Preview.propTypes = {
  allData: PropTypes.object.isRequired,
}
